import { Document } from "@react-pdf/renderer";
import type { PropsWithChildren } from "react";
import React from "react";
import { DocumentContext } from "../../components/context";
import { Heading } from "../../components/heading";
import { Page } from "../../components/page";
import type { DocumentProps } from "../../components/types";

/** Props Interface */
interface PreviewProps extends DocumentProps, PropsWithChildren {}

export function Preview({ logoUrl, letterPaperUrl, workspaceMetadata }: PreviewProps) {
	/** Render */
	return (
		<React.Fragment>
			<DocumentContext.Provider
				value={{
					logoUrl,
					letterPaperUrl,
					workspaceMetadata,
				}}
			>
				<Document>
					<Page>
						<Heading fixed>Sample Document</Heading>
					</Page>
				</Document>
			</DocumentContext.Provider>
		</React.Fragment>
	);
}
